import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom"

const useNavigationEnabled = () => {
    const location = useLocation();  
    const { isAuthenticated } = useAuth0();

    const blacklistedLocationPaths = [
        '/logged-in',
        '/register',
        '/tos',
        '/unsubscribe',
    ];

    const blackListedLocationPrefixes = [
        '/forms/public/'
    ];

    return !blacklistedLocationPaths.includes(location.pathname) && 
        !blackListedLocationPrefixes.some(p => location.pathname.startsWith(p)) && 
        isAuthenticated;
}

export default useNavigationEnabled;